<style>
.error-page .user-reset .el-form-item__error {
  position: relative;
  text-align: left;
}

.error-page .el-header {
  text-align: left;
  line-height: 60px;
  font-size: 20px;
  background-color: #FFF;
  margin-bottom: 0;
  color: #007967;
}

.error-page .el-footer {
  text-align: left;
  font-size: 20px;
  margin-bottom: 0;
}

.error-page .body-body {
  text-align: center;
  margin: 0 auto;
}

.error-page .contain {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  height: auto;
}

.error-page .login {
  width: 460px;
  display: inline-block;
  padding: 5px;
}

.error-page .login .input {
  height: 300px;
  border: 2px solid rgb(238, 238, 238);
  border-radius: 10px;
  background-color: #FFF;
}

.error-page h3 {
  font-size: 25px;
  font-weight: normal;
  padding-top: 30px;
  padding-bottom: 5px;
}

.error-page table,.error-page tr,.error-page td {
  border: 0px;
  border-collapse: collapse;
}

.error-page table {
  width: 100%;
}

.error-page .input .text {
  width: 330px;
  height: 40px;
  background-color: rgb(238, 238, 238);
}

.error-page .input .text:focus {
  background-color: rgb(255, 255, 255)
}

.error-page .button {
  margin-top: 15px;
  height: 40px;
  width: 350px;
  background-color: rgb(141, 205, 71);
  border-radius: 5px;;
  color: rgb(255, 255, 255);
}

.error-page .info1 {
  margin-top: 25px;
}

.error-page .info1 a {
  color: rgb(91, 155, 213);
}

.error-page .info1 a:hover {
  color: #ed6d34;
}

.error-page .info1 p {
  margin-top: 35px;
  margin-bottom: 10px;
  font-size: 15px;
}

.error-page .info1 .p {
  font-size: 15px;
  text-decoration: underline;
}

.error-page .error {
  color: red;
}

.error-page .title {
  width: 600px;
  height: 50px;
  border: 1px solid;
  margin: 15px auto;
  line-height: 50px;
  background-color: rgb(242, 242, 242);
  font-size: 20px;
}

.error-page .content {
  width: 600px;
  margin: 15px auto;
  text-align: left
}

.error-page .content p {
  margin-top: 5px;
}

.error-page .login2 .button {
  margin-top: 5px;
  border-radius: 10px;
}

.error-page #footer-footer {
  border-width: 0px;
  left: 0px;
  top: 0px;
  width: 100%;
  background: inherit;
  background-color: rgba(242, 242, 242, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(215, 215, 215, 1);
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 18px;
}

.error-page .img {
  position: relative;
  margin-top: -82px;
}

.error-page .el-main {
  display: block;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  overflow: auto;
  box-sizing: border-box;
}

.error-page #footer-footer p {
  text-align: center;
  border-width: 0px;
  word-wrap: break-word;
  text-transform: none;
}

.error-page .middle {
  display: flex;
}

.error-page #Login_userID,.error-page #Login_passwd {
  height: 100%;
  width: 100%;
}

.error-page .body-body .el-header {
  border-top: 3px solid #007967
}
</style>
<template>
  <div>
    <el-container class="contain">
      <el-header>信服集团管理系统</el-header>
      <el-main style="display:flex;align-items: left;justify-content: left;">
        <div>
          <ul>
            <li class="error">ERROR : 发生错误。若长时间发生错误时，请咨询本公司客户支持。</li>
            <br>
            <li>5秒后自动返回到登录页。</li>
            <li>不自动返回时
              <span @click="toLogin()" style="color:blue;cursor: pointer">登录页</span>
            </li>
          </ul>
        </div>
      </el-main>

      <el-footer style="height:auto;">
        <div id="footer-footer">
          <p><span>联系我们：03-5289-3421(TEL)<br>—©浙江信服会计师事务所有限公司 All Rights Reserved.—</span></p>
          <img style="cursor: pointer;width: 120px;height: 82px" id="u6_img" class="img" :src="imgu6_url">
        </div>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import imgu6 from '@/assets/image/LOGO_xinfu.png'

export default {
  name: 'error500'
  , data() {
    return {
      time: 0
      , imgu6_url: imgu6
    }
  }
  , methods: {
    countDown() {
      let THIS = this;
      THIS.time--;
    }
    ,toLogin() {
      this.$store.dispatch('logout')
      this.$router.push({ name: 'login' })
    }
  }
  , mounted() {
    let THIS = this;
    THIS.time = 5;
    setInterval(THIS.countDown, 1000);
  }
  , watch: {
    'time': function (newVal, oldVal) {
      if (newVal == 0) {
        this.$router.push('login');
      }
    }
  }
};
</script>
